import { movies } from "@/mocks/movies";
import MovieCard from "@/components/feature/MovieCard";
import SectionHeading from "@/components/feature/SectionHeading";

export default function HotMovies() {
  const hot = [...movies].sort((a, b) => b.heat - a.heat).slice(0, 8);

  return (
    <section className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
      <SectionHeading
        eyebrow="Trending Now"
        title="本月热门推荐"
        description="根据影迷关注热度与口碑综合排出的本期热门片单，帮你快速锁定值得一看的影片。"
        moreTo="/list/hot"
        moreLabel="完整热榜"
      />
      <div className="grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-4">
        {hot.map((movie) => (
          <MovieCard key={movie.id} movie={movie} />
        ))}
      </div>
    </section>
  );
}